import { render } from "./ClientsCard.vue?vue&type=template&id=dc337938&scoped=true"
import script from "./ClientsCard.vue?vue&type=script&lang=js"
export * from "./ClientsCard.vue?vue&type=script&lang=js"

import "./ClientsCard.vue?vue&type=style&index=0&id=dc337938&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc337938"]])

export default __exports__